import { QuestionnaireInstance, QuestionnaireStatus } from 'graphql/codegen/schemas';

export const isSurveyUsable = (q: { status: QuestionnaireStatus; value?: number | null | undefined }) =>
  q.status !== QuestionnaireStatus.Initial && (q.status !== QuestionnaireStatus.Missed || !!q.value);
